function now ()
{
	if (window.performance && window.performance.now) {
		return performance.timeOrigin + performance.now()
	}

	return Date.now()
}

export function ticker (f)
{
	let time = 0, frame = 0
	let start_time = now(), last_update = start_time
	let id, req

	const w = window, listeners = []
	const raf = w ? w.requestAnimationFrame : null
	const cancel = w ? w.cancelAnimationFrame : clearTimeout

	const lag_threshold = 500, adjusted_lag = 33
	const default_fps = 240, default_gap = 1000 / default_fps

	let gap = default_gap, next_time = gap

	function tick ()
	{
		let i = listeners.length
		let delta = 0, dispatch = 0
		const elapsed = now() - last_update
		elapsed > lag_threshold && (start_time += elapsed - adjusted_lag)

		last_update += elapsed
		const t = last_update - start_time
		const time_delta = t - next_time
		if (time_delta > 0) {
			++frame
			delta = t - time
			time = t
			next_time += time_delta + (time_delta >= gap ? default_gap : gap - time_delta)
			dispatch = 1
		}

		id = req(tick)

		if (dispatch) {
			const fps = 1000 / delta
			while (i--) listeners[i](t, delta, frame, fps)
		}
	}

	const self = {

		unsubscribe (f)
		{
			const i = listeners.indexOf(f);
			if (i !== -1) {
				listeners.splice(i, 1);
			}
		},

		subscribe (callback, once = false, prioritize = false)
		{
			if (typeof (callback) === 'function') {
				const func = once ? (t, d, f) => {
					callback(t, d, f);
					self.unsubscribe(func);
				} : callback;

				self.unsubscribe(callback)

				if (prioritize) {
					listeners.push(func)
				}
				else {
					listeners.unshift(func)
				}

				self.wake()
			}
		},

		tick,

		wake ()
		{
			id && this.sleep()

			req = raf || setTimeout(f, (next_time - time * 1000 + 1) | 0)

			tick()
		},

		sleep ()
		{
			cancel(id);
			req = () => {}
		},

		fps (v)
		{
			gap = 1000 / (v || default_fps)
			return self
		}
	}

	self.subscribe(f)

	return self
}